import { HttpErrorResponse } from '@angular/common/http';
import { BaseHttpResponseError } from './base-http.error';
import {
  ItemNotFoundInDatabaseError,
  RecordNotFoundInEDPDatabaseError,
  UnauthorizedGeoPermissionsError,
} from './error-700-not-in-database.error';
import { ItemAlreadyExistsError } from './error-801-item-already-exists.error';
import { UserNotFoundError } from './error-900-user-not-found';
import {
  ActiveExportError,
  DownloadLimitsNotSetError,
  ExportLogError,
  UserLimitReachedError,
} from './error-export-limits.error';
import { CannotReadS3StorageError, CannotWriteS3StorageError, StorageError } from './error-storage.error';
import { UnauthorizedRequest } from './unauthorized-401.error';

export enum ErrorCodes {
  ExportLog = 100,
  ActiveExport = 101,
  UserLimitReached = 102,
  DownloadLimitsNotSet = 103,
  Storage = 200,
  CannotReadS3Storage = 201,
  CannotWriteS3Storage = 202,
  UnauthorizedRequest = 401,
  ItemNotFoundInDatabase = 700,
  RecordNotFoundInEDPDatabase = 702,
  UnauthorizedGeoPermissions = 703,
  ItemAlreadyExists = 801,
  UserNotFound = 900,
}

/**
 * Factory class for Errors
 */
export class ErrorFactory {
  public static GetError(rootError: HttpErrorResponse): BaseHttpResponseError {
    switch (rootError.error?.code ?? rootError.status) {
      case ErrorCodes.ExportLog:
        return new ExportLogError(rootError);
      case ErrorCodes.ActiveExport:
        return new ActiveExportError(rootError);
      case ErrorCodes.UserLimitReached:
        return new UserLimitReachedError(rootError);
      case ErrorCodes.DownloadLimitsNotSet:
        return new DownloadLimitsNotSetError(rootError);
      case ErrorCodes.Storage:
        return new StorageError(rootError);
      case ErrorCodes.CannotReadS3Storage:
        return new CannotReadS3StorageError(rootError);
      case ErrorCodes.CannotWriteS3Storage:
        return new CannotWriteS3StorageError(rootError);
      case ErrorCodes.ItemNotFoundInDatabase:
        return new ItemNotFoundInDatabaseError(rootError);
      case ErrorCodes.RecordNotFoundInEDPDatabase:
        return new RecordNotFoundInEDPDatabaseError(rootError);
      case ErrorCodes.UnauthorizedGeoPermissions:
        return new UnauthorizedGeoPermissionsError(rootError);
      case ErrorCodes.ItemAlreadyExists:
        return new ItemAlreadyExistsError(rootError);
      case ErrorCodes.UserNotFound:
        return new UserNotFoundError(rootError);
      case ErrorCodes.UnauthorizedRequest:
        return new UnauthorizedRequest(rootError);
      default:
        return new BaseHttpResponseError(rootError);
    }
  }
}
